module.exports = __webpack_public_path__ + "static/media/RPR 2a.0dde9c81.jpg";